import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import {verificaCache} from '../../../verificaCache';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';


class Planos extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            data: 'loading',
            showTable: false,
            abrangencias: [],

            errorRequest: false,
            msgErrorRequest: '',
            successRequest: false,
            msgSuccessRequest: '',
        };

        this.styles = {
            theadTr: {
                textTransform: "uppercase",
            },
            theadTh: {
                height: 35,
            },
            inputSearch: {
                marginLeft: 8,
                flex: 1,
            },
        };
    }

    componentDidMount() {
        this._isMounted = true;
        verificaCache(function (vc) {
            if (this._isMounted && vc.erro === false) {
                this.getAbrangencias();
                this.getData();
            } else if (this._isMounted) {
                this.setError(vc.mensagem);
            }
        }.bind(this));
    }
    
    componentWillUnmount() {
        this._isMounted = false;
    }

    getAbrangencias() {
        axios.get(`${configBase.api}Abrangencia?access_token=${localStorage.getItem('planos_t')}`)
            .then(response => {
                if (this._isMounted) {
                    this.setState({ abrangencias: response.data });
                }
            })
            .catch(error => {
                if (this._isMounted) {
                    this.setError('Erro ao carregar abrangências.');
                }
            });
    }

    getData() {
        let url = configBase.api + 'Plans?access_token=' + localStorage.getItem('planos_t');

        axios.get(url)
        .then((response) => {
            if (this._isMounted) {
                let state = this.state;
                if (response.data.length === 0)
                    state.data = 'zero';
                else
                    state.data = response.data;

                if (state.showTable === false) {
                    state.showTable = true;
                    $(document).ready(function () {
                        let table = $('#table_id').DataTable({
                            "dom": 'rtip',
                            "language": {
                                "url": `${process.env.PUBLIC_URL}/plugins/datatables/Portuguese-Brasil.lang`
                            },
                            "infoCallback": function( settings, start, end, max, total, pre ) {
                                document.getElementById('tablePageStart').innerHTML = start;
                                document.getElementById('tablePageEnd').innerHTML = end;
                                document.getElementById('tablePageTotal').innerHTML = total;
                                return '';
                            },
                            pagingType: "simple",
                            oLanguage: {
                                oPaginate: {
                                    sNext: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path></svg>',
                                    sPrevious: '<svg class="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small"><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path></svg>'
                                },
                            },
                            "scrollX": true,
                        });

                        $('#mySearchText').on( 'keyup', function () {
                            table.search($('#mySearchText').val()).draw();
                        } );

                        $('#myLengthMenu').on( 'change', function () {
                            table.page.len($('#myLengthMenu').val()).draw();
                        } );
                    });
                }
                this.setState(state);
            }
        })
        .catch(() => {
            if (this._isMounted) {
                this.setError('Problema encontrado ao buscar Planos');
            }
        });
    }

    sendAddPlan() {
        this.props.history.push(`${process.env.PUBLIC_URL}/novoplano`);
    }

    editPlan(id) {
        this.props.history.push(`${process.env.PUBLIC_URL}/novoplano?id=${id}`);
    }

    setError(msg) {
        let state = this.state;
        state.errorRequest = true;
        state.msgErrorRequest = msg;
        this.setState(state);
    }

    errorClose = () => {
        let state = this.state;
        state.errorRequest = false;
        state.msgErrorRequest = '';
        this.setState(state);
    }

    setSuccess(msg) {
        let state = this.state;
        state.successRequest = true;
        state.msgSuccessRequest = msg;
        this.setState(state);
    }

    successClose = () => {
        let state = this.state;
        state.successRequest = false;
        state.msgSuccessRequest = '';
        this.setState(state);
    }

    render() {
        const { data } = this.state;

        return (
            <MainLayout history={this.props.history}>
                <div id="Planos" className={{flexGrow: 1}}>
                    <Paper elevation={0} className="paper">
                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                                    Planos
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                                <div className="botoesDeEnvio">
                                    <Button
                                        variant="contained"
                                        style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria, marginRight: 5}}
                                        startIcon={<AddIcon />}
                                        size="small"
                                        onClick={this.sendAddPlan.bind(this)}
                                    >
                                        CADASTRAR PLANO
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>

                    <div id="PlanosConteudo" className="contentepanel">
                    {
                        data === 'loading' ? (
                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                                <LinearProgress />
                                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                                    BUSCANDO PLANOS...
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                        </Grid>
                        ) : (
                            data === 'error' ? (
                            <Grid container spacing={0}>
                                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <Alert severity="error">Problema ao buscar lista de Planos</Alert>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                            </Grid>
                            ) : (
                                data === 'zero' ? (
                            <Grid container spacing={0}>
                                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <Alert severity="info">Sem Planos cadastrados</Alert>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                            </Grid>
                                ) : (
                            <div id="PlanosTabela">
                                {/* ############# CSS PARA DATATABLE ############# */}
                                <link
                                    rel="stylesheet" type="text/css"
                                    href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
                                />
                                <link
                                    rel="stylesheet" type="text/css"
                                    href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
                                />
                                {/* ############# CSS PARA DATATABLE ############# */}

                                <Grid container spacing={0}>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>{''}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4}>{''}
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4} lg={4} style={{marginBottom: 20}}>
                                        <Paper elevation={1}>
                                            <IconButton style={{padding: '6px 5px'}} aria-label="search">
                                                <SearchIcon />
                                            </IconButton>
                                            <InputBase
                                                id="mySearchText"
                                                style={this.styles.inputSearch}
                                                placeholder="Pesquisar"
                                                inputProps={{ 'aria-label': 'search google maps' }}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>

                                <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                                    <thead style={{width:'100%', backgroundColor: configBase.corPrincipal}}>
                                        <tr style={this.styles.theadTr}>
                                            <th style={this.styles.theadTh}>
                                                <Typography
                                                    variant="button" display="block" gutterBottom
                                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                                                >
                                                    Nome
                                                </Typography>
                                            </th>
                                            <th style={this.styles.theadTh}>
                                                <Typography
                                                    variant="button" display="block" gutterBottom
                                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                                                >
                                                    Código S4
                                                </Typography>
                                            </th>
                                            <th style={this.styles.theadTh}>
                                                <Typography
                                                    variant="button" display="block" gutterBottom
                                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                                                >
                                                    Valor
                                                </Typography>
                                            </th>
                                            <th style={this.styles.theadTh}>
                                                <Typography
                                                    variant="button" display="block" gutterBottom
                                                    style={{color: configBase.corSecundaria, margin:0, fontSize: 12}}
                                                >
                                                    AÇÕES
                                                </Typography>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr
                                                key={index}
                                                className="row_table"
                                                style={this.styles.theadTh}
                                            >
                                                <td style={{padding: 0, height: 40}}>
                                                    <Typography variant="overline" display="block" gutterBottom
                                                        style={{color: '#757575', margin: 0, fontSize: 11}}
                                                    >
                                                        {item.name}
                                                    </Typography>
                                                </td>
                                                <td style={{padding: 0, height: 40}}>
                                                    <Typography variant="overline" display="block" gutterBottom
                                                        style={{color: '#757575', margin: 0, fontSize: 11}}
                                                    >
                                                        {item.codeS4}
                                                    </Typography>
                                                </td>
                                                <td style={{padding: 0, height: 40}}>
                                                    <Typography variant="overline" display="block" gutterBottom
                                                        style={{color: '#757575', margin: 0, fontSize: 11}}
                                                    >
                                                        R$ {item.value}
                                                    </Typography>
                                                </td>
                                                <td style={{padding: 0, height: 40}}>
                                                    <div>
                                                        <IconButton
                                                            aria-label="edit"
                                                            style={{padding: '8px 8px'}}
                                                            onClick={this.editPlan.bind(this, item.id)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                </table>

                                <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                                    <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                                        <label htmlFor="myLengthMenu">Linhas por página: </label>
                                        <select id="myLengthMenu" style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                        <span id="tablePageStart" style={{marginLeft: 15}}></span>-<span id="tablePageEnd"></span>
                                        {' '}de{' '}
                                        <span id="tablePageTotal"></span>
                                    </div>
                                </div>
                            </div>
                                )
                            )
                        )
                    }
                    </div>

                    <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose}>
                        <MuiAlert className="snackbarStyle" onClose={this.errorClose} severity="error" variant="filled" elevation={6}>
                            {this.state.msgErrorRequest}
                        </MuiAlert>
                    </Snackbar>

                    <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose}>
                        <MuiAlert className="snackbarStyle" onClose={this.successClose} severity="success" variant="filled" elevation={6}>
                            {this.state.msgSuccessRequest}
                        </MuiAlert>
                    </Snackbar>
                </div>
            </MainLayout>
        );
    }
}

Planos.propTypes = {
    history: PropTypes.object
};

export default withRouter(Planos);